module.exports = __webpack_public_path__ + "static/media/c3be2d9e.jpg";